import styled from 'styled-components';

const MostWantedStyle = styled.section`
	--gapDistance: var(--sp4x);
	--distanceTitle: var(--sp9x);
	--padDescriptionLR: var(--sp6x);
	--padDescriptionT: var(--sp4x);
	--padDescriptionB: var(--sp6x);
	--distanceButtonDescription: var(--sp6x);
	--radiusLeft: var(--sp6x);

	/* img {
		transition: opacity 0s !important;
	} */

	.title-section {
		margin-bottom: var(--distanceTitle);
	}

	.content-right-bar,
	.inner-wrapper {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: var(--gapDistance);
	}

	.inner-wrapper-right-bar {
		overflow: hidden;
	}

	.left-bar {
		.inner-wrapper-left-bar {
			display: flex;
			flex-direction: column;
			border: 1px solid var(--neutral600);
			border-radius: var(--radiusLeft);
			overflow: hidden;
			max-height: calc(100vh - (var(--headerFixedHeight) + var(--headerBannerHeight))) !important;
		}

		.wrapper-image {
			flex: 1;
		}

		.image-cont {
			--proportion: 0px;
			height: 100%;
		}

		.wrapper-description-button {
			height: fit-content;
		}

		.inner-wrapper-description {
			display: flex;
			flex-direction: column;
			gap: var(--distanceButtonDescription);
			padding: var(--padDescriptionT) var(--padDescriptionLR) var(--padDescriptionB);
		}
	}

	.item-product-skeleton {
		position: relative;
		--proportion: 0;

		img {
			position: relative !important;
			width: 100% !important;
			height: auto !important;
		}
	}

	p {
		will-change: transform;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--gapDistance: var(--sp3x);
		--distanceTitle: var(--sp6x);
		--padDescriptionLR: var(--sp4x);
		--padDescriptionT: var(--sp6x);
		--padDescriptionB: var(--sp4x);
		--distanceButtonDescription: var(--sp4x);
		--radiusLeft: var(--sp3x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--gapDistance: var(--sp3x);
		--distanceTitle: var(--sp6x);
		--padDescriptionLR: var(--sp4x);
		--padDescriptionT: var(--sp4x);
		--padDescriptionB: var(--sp4x);
		--distanceButtonDescription: var(--sp3x);
		--radiusLeft: var(--sp4x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--gapDistance: var(--sp2x);
		--distanceTitle: var(--sp4x);
		--padDescriptionLR: var(--sp3x);
		--padDescriptionT: var(--sp6x);
		--padDescriptionB: var(--sp3x);
		--distanceButtonDescription: var(--sp3x);
		--radiusLeft: var(--sp4x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--gapDistance: var(--sp2x);
		--distanceTitle: var(--sp4x);
		--padDescriptionLR: var(--sp3x);
		--padDescriptionT: var(--sp4x);
		--padDescriptionB: var(--sp3x);
		--distanceButtonDescription: var(--sp3x);
		--radiusLeft: var(--sp2-5x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--gapDistance: var(--sp2x);
		--distanceTitle: var(--sp4x);
		--padDescriptionLR: var(--sp2x);
		--padDescriptionT: 0px;
		--padDescriptionB: 0px;
		--distanceButtonDescription: var(--sp3x);
		--radiusLeft: var(--sp2-5x);

		.inner-wrapper {
			display: flex;
			flex-direction: column;
		}

		.content-right-bar {
			grid-template-columns: repeat(3, 1fr);
		}

		.content-right-bar {
			.item-product {
				&.ended-child-1 {
					transform: translateX(calc(100% + var(--gapDistance)));
				}

				&.ended-child-2 {
					transform: translateX(calc(100% - ((100% - var(--gapDistance)) / 2)));
				}
			}
		}

		.left-bar {
			.inner-wrapper-left-bar {
				display: flex;
				flex-direction: row;
				max-height: none !important;
			}

			.image-cont {
				--proportion: 89.4%;
				height: 100%;
				width: 52.6vw;
			}

			.wrapper-description-button {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				height: auto;
			}
		}
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--gapDistance: var(--sp1x);
		--distanceTitle: var(--sp3x);
		--padDescriptionLR: var(--sp2x);
		--padDescriptionT: var(--sp5x);
		--padDescriptionB: var(--sp2x);
		--distanceButtonDescription: var(--sp2x);
		--radiusLeft: var(--sp3x);

		.content-right-bar {
			grid-template-columns: repeat(2, 1fr);
		}

		.content-right-bar {
			.item-product {
				&.ended-child-1 {
					transform: translateX(0);
				}

				&.ended-child-2 {
					transform: translateX(0);
				}
			}
		}

		.left-bar {
			.inner-wrapper-left-bar {
				display: flex;
				flex-direction: column;
			}

			.image-cont {
				--proportion: 107%;
				height: 100%;
				width: 100%;
			}

			.wrapper-description-button {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				height: auto;
			}
		}
	}
`;
export default MostWantedStyle;
